/* UPP redesign: cart drawer and cart page additions (snippets/cart-drawer.liquid, sections/main-cart.liquid).
   Impulse's theme.CartDrawer / theme.CartForm (assets/theme.js) still open the drawer and refill
   [data-products] from the cart-ajax section; this file only adds to that:
   - footer subtotal / estimated total and the drawer's header count, copied from the refilled markup
   - "Added: <title>, <size>" after an add
   - Remove without leaving the page (theme.cart.changeItem + the theme's cart:build event)
   - the "Add a note" toggle
   - the chair suggestion's Add (fills #UppCartSuggestForm, submitted by theme.AjaxProduct)
   - delivery estimates (window.uppEta) and focus kept on the control that was used
   - delivery add-ons (snippets/upp-cart-line, added by assets/upp-pdp.js): after every cart change
     (quantity, Remove, minus at 1, an add, page load with add-ons) the expedite line follows its
     piece's quantity (_upp_for = the piece's _upp_link), lines whose piece is gone go to 0, and one
     white glove line (_upp_wg) stays while any piece has Delivery "White glove". One /cart/update.js
     call when something is off; its cart:updated then finds nothing to do. */
(function () {
  'use strict';
  if (window.__uppCart) return;
  window.__uppCart = true;

  var drawer = document.getElementById('CartDrawer');
  var page = document.getElementById('CartPageForm');
  var suggestForm = document.getElementById('UppCartSuggestForm');
  var fixingStale = false, staleTried = {}; // stale add-on cleanup (wire > fixStale)
  var fixingProps = false, propsTried = {}; // checkout lead-time lines (wire > fixProps)
  var LT_KEYS = ['Production', 'In stock', 'Ships in', 'Estimated delivery'];
  var CHECK = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M5 12l4 4 10-10"/></svg>';

  // The drawer is printed inside the header section, which is sticky with its own z-index, so the
  // page overlay (.main-content::after) would sit above it. Hang it off <body> instead; the node
  // and its listeners stay the same.
  if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var f = window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat;
    var s = f ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat) : '$' + (cents / 100).toFixed(2);
    return s.replace(/\.00(?=\D*$)/, '');
  }
  // Matching chairs (snippets/upp-cart-suggest + assets/upp-chair-match.js): up to 3 styles, each
  // with its own Add (handled by the [data-upp-suggest] click below). The single row stays without JS.
  function renderChairs(scope) {
    if (!window.uppChairMatch) return;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-upp-chairs]:not([data-upp-chairs-done])'), function (box) {
      var d;
      try { d = JSON.parse(box.querySelector('[data-upp-chairs-data]').textContent); } catch (e) { return; }
      // How many styles: the product page's "Chair styles to suggest" (data.set.styles) when it's on the
      // page, else 3. The table's own picks (kind 'pick') ignore it.
      var styles = 3;
      try {
        var pj = document.querySelector('[data-upp-pdp-json]');
        var ps = pj && JSON.parse(pj.textContent).set;
        if (ps && ps.styles) styles = Math.max(1, Math.min(3, parseInt(ps.styles, 10) || 3));
      } catch (e) { /* default */ }
      var res = window.uppChairMatch.pick(d.chairs, { woods: d.woods, values: d.values, max: styles });
      var items = res.items.filter(function (it) { return it.variant; });
      if (!items.length) return;
      var q = d.qty;
      var head = res.kind === 'pairs' ? 'Pairs well · ' + q + ' chairs' : String(d.text || 'Add [qty] matching chairs').replace('[qty]', q);
      box.innerHTML = '<p class="upp-cd__chairs-head">' + esc(head) + '</p><ul class="upp-cd__chairs-list" role="list">' + items.map(function (it) {
        var c = it.chair, v = it.variant;
        return '<li class="upp-cd__suggest">' +
          '<a href="' + esc(c.u) + '" class="upp-cd__suggest-img" tabindex="-1" aria-hidden="true">' + (c.img ? '<img src="' + esc(c.img) + '" srcset="' + esc([96, 192, 288].map(function (w) { return c.img.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w'; }).join(', ')) + '" sizes="(min-width: 1440px) 96px, (min-width: 1024px) 88px, 64px" alt="" loading="lazy" width="88" height="110">' : '') + '</a>' +
          '<div class="upp-cd__suggest-text"><a href="' + esc(c.u) + '" class="upp-cd__suggest-name">' + esc(c.t) + '</a>' +
          '<span class="upp-cd__suggest-meta">' + money(v.p) + ' each · ' + money(v.p * q) + ' for ' + q + '</span></div>' +
          '<button type="button" class="upp-cd__suggest-btn" data-upp-suggest data-variant="' + v.id + '" data-qty="' + q + '" aria-label="Add ' + q + ' ' + esc(c.t) + ', ' + money(v.p * q) + '">Add</button></li>';
      }).join('') + '</ul>';
      box.setAttribute('data-upp-chairs-done', '');
    });
  }

  // root: #CartDrawer or #CartPageForm
  function wire(root, isDrawer) {
    var products = root.querySelector('[data-products]');
    if (!products) return;
    var addedEl = root.querySelector('[data-upp-added]');
    // /cart has no "Added" line in its markup: give it the drawer's live region so the add-on and stale
    // notes are seen and announced there too (review 2026-10-18).
    if (!addedEl && !isDrawer) {
      addedEl = document.createElement('p');
      addedEl.className = 'upp-cd__added';
      addedEl.setAttribute('data-upp-added', '');
      addedEl.setAttribute('role', 'status');
      addedEl.setAttribute('aria-live', 'polite');
      addedEl.setAttribute('tabindex', '-1');
      products.parentNode.insertBefore(addedEl, products);
    }
    // One-line note for the next refill of THIS cart (drawer or /cart), so the hidden drawer can't take
    // the /cart page's note.
    var staleNote = '';
    var countEl = root.querySelector('[data-upp-cart-count]');
    var subEl = root.querySelector('[data-upp-items-subtotal]');
    var totalEl = root.querySelector('[data-subtotal]');
    var busyEl = isDrawer ? root : root.parentNode;
    var refocus = null;

    // The size comes from the refilled line (data-upp-size, the visitor's units via snippets/upp-dim);
    // until the refill lands, Shopify's variant title stands in.
    var lastAdded = null;
    function showAdded(item) {
      if (!addedEl || !item || !item.product_title) return;
      lastAdded = item;
      var title = String(item.product_title).split(',')[0].trim();
      var line = item.key ? products.querySelector('.upp-cl[data-key="' + (window.CSS && CSS.escape ? CSS.escape(item.key) : item.key) + '"]') : null;
      var size = line && line.hasAttribute('data-upp-size') ? line.getAttribute('data-upp-size')
        : (item.variant_title ? String(item.variant_title).split(' | ')[0].replace(/x/g, '×').replace(/"/g, '″') : '');
      var qty = item.quantity > 1 ? item.quantity + ' × ' : '';
      addedEl.innerHTML = CHECK + '<span>Added: ' + esc(qty + title + (size ? ', ' + size : '')) + '</span>';
    }
    function clearAdded() { lastAdded = null; if (addedEl) addedEl.innerHTML = ''; }

    // A piece whose add-on no longer applies (snippets/upp-cart-line data-upp-stale): clear its
    // Delivery + link, let reconcile drop the orphaned add-on line, and say so in one quiet line.
    function fixStale() {
      if (isDrawer && page) return; // on /cart the page form fixes and reports it (review 2026-10-18)
      var stale = Array.prototype.slice.call(products.querySelectorAll('.upp-cl[data-upp-stale]')).filter(function (l) {
        return !staleTried[l.getAttribute('data-key')];
      });
      // An add-on product added on its own (its product page, a cart link): no piece to go with, and
      // the cart prints nothing for it, so drop it (snippets/upp-cart-line data-upp-bare-addon).
      var bare = Array.prototype.slice.call(products.querySelectorAll('[data-upp-bare-addon]')).filter(function (l) {
        return !staleTried[l.getAttribute('data-upp-bare-addon')];
      });
      if ((!stale.length && !bare.length) || fixingStale) return;
      stale.forEach(function (l) { staleTried[l.getAttribute('data-key')] = true; });
      bare.forEach(function (l) { staleTried[l.getAttribute('data-upp-bare-addon')] = true; });
      fixingStale = true;
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var notes = stale.map(function (l) {
        return (l.getAttribute('data-upp-stale') === 'wg' ? 'White glove' : 'Expedite') + ' no longer applies to ' + (l.getAttribute('data-upp-name') || 'this piece') + '; removed.';
      }).concat(bare.map(function (l) {
        return (l.getAttribute('data-upp-name') || 'This add-on') + ' is added from a piece\'s delivery options; removed.';
      }));
      fetch(rootUrl + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return stale.reduce(function (chain, l) {
            return chain.then(function () {
              var it = cart.items.filter(function (x) { return x.key === l.getAttribute('data-key'); })[0];
              if (!it) return null;
              var props = Object.assign({}, it.properties || {});
              // Blank values (an empty properties object is ignored by /cart/change.js); blank ones aren't shown.
              props.Delivery = ''; props._upp_link = '';
              return fetch(rootUrl + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: json, body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props }) });
            });
          }, Promise.resolve());
        })
        .then(function () { return fetch(rootUrl + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var body = { updates: addonUpdates(cart) || {} };
          bare.forEach(function (l) {
            var k = l.getAttribute('data-upp-bare-addon');
            if (cart.items.some(function (x) { return x.key === k; })) body.updates[k] = 0;
          });
          var sec = window.theme && theme.cart && theme.cart.drawerSection;
          if (sec) body.sections = sec;
          return fetch(rootUrl + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: json, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
        })
        .then(function (c2) {
          fixingStale = false;
          staleNote = notes.join(' ');
          if (c2 && c2.sections) document.dispatchEvent(new CustomEvent('cart:build', { detail: { sections: c2.sections } }));
          else if (!isDrawer) window.location.reload();
        })
        .catch(function () { fixingStale = false; });
    }

    // Checkout lead-time lines (owner 2026-10-18; snippets/upp-cart-lt-props): the checkout shows a line's visible
    // properties under the item, so each piece gets "Production" (or "In stock" / "Ships in") and, on Standard,
    // "Estimated delivery"; its Expedite line and the White glove line get "Estimated delivery". Lines whose
    // properties differ get one /cart/change.js each (other properties kept), then the cart is rebuilt once.
    // Each wanted value is tried once per line, so a refused change never loops.
    function fixProps() {
      if (isDrawer && page) return; // on /cart the page form does it
      if (fixingStale || fixingProps) return;
      var want = {}, allOk = true;
      Array.prototype.forEach.call(products.querySelectorAll('[data-upp-lt-props]'), function (el) {
        try { JSON.parse(el.textContent).forEach(function (x, i) { want[x.k] = x.p; if (i === 0 && !x.ok) allOk = false; }); } catch (e) { /* skip */ }
      });
      // every line already right (the markup says so): no /cart.js round trip
      if (!Object.keys(want).length || allOk) return;
      fixingProps = true;
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var done = function () { fixingProps = false; };
      fetch(rootUrl + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var todo = cart.items.filter(function (it) {
            var w = want[it.key], p = it.properties || {};
            if (!w) return false;
            var off = LT_KEYS.some(function (k) { return String(p[k] || '') !== String(w[k] || ''); });
            var sig = it.key + JSON.stringify(w);
            if (!off || propsTried[sig]) return false;
            propsTried[sig] = true;
            return true;
          });
          if (!todo.length) { done(); return null; }
          return todo.reduce(function (chain, it) {
            return chain.then(function () {
              var props = Object.assign({}, it.properties || {}), w = want[it.key];
              LT_KEYS.forEach(function (k) { if (w[k] || props[k]) props[k] = w[k] || ''; });
              return fetch(rootUrl + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: json, body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props }) });
            });
          }, Promise.resolve()).then(function () {
            var body = { updates: {} };
            var sec = window.theme && theme.cart && theme.cart.drawerSection;
            if (sec) body.sections = sec;
            return fetch(rootUrl + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: json, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
          }).then(function (c2) {
            done();
            if (c2 && c2.sections) document.dispatchEvent(new CustomEvent('cart:build', { detail: { sections: c2.sections } }));
            else if (!isDrawer) window.location.reload();
          });
        })
        .catch(done);
    }

    // After every refill of [data-products] (page load, add, quantity change, remove).
    function sync() {
      var items = products.querySelector('.cart__items');
      if (!items) return;
      var n = parseInt(items.getAttribute('data-count'), 10) || 0;
      if (!isDrawer && n === 0) { window.location.reload(); return; }
      if (countEl) countEl.textContent = n > 0 ? ' (' + n + ')' : '';
      if (subEl && items.dataset.uppSubtotal) subEl.textContent = items.dataset.uppSubtotal;
      if (totalEl && items.dataset.uppTotal) totalEl.textContent = items.dataset.uppTotal;
      var delEl = root.querySelector('[data-upp-delivery-text]');
      if (delEl && items.dataset.uppDelivery) delEl.textContent = items.dataset.uppDelivery;
      var saveRow = root.querySelector('[data-upp-save-row]');
      if (saveRow) {
        var sv = items.dataset.uppSave || '';
        saveRow.hidden = !sv;
        if (sv) saveRow.querySelector('[data-upp-save]').textContent = sv;
      }
      if (window.uppEta) window.uppEta(products);
      renderChairs(products);
      fixStale();
      fixProps();
      if (lastAdded && addedEl && addedEl.innerHTML) showAdded(lastAdded);
      if (staleNote && addedEl) { addedEl.textContent = staleNote; staleNote = ''; }
      if (!refocus) return;
      var r = refocus;
      refocus = null;
      var target = null;
      var line = r.key ? products.querySelector('.upp-cl[data-key="' + (window.CSS && CSS.escape ? CSS.escape(r.key) : r.key) + '"]') : null;
      // A Delivery change gives the piece a new key: fall back to its place in the list.
      if (!line && r.idx != null && r.idx >= 0) line = products.querySelectorAll('.upp-cl')[r.idx] || null;
      if (line) {
        target = line.querySelector(r.sel);
        if (target && target.disabled) target = line.querySelector('.js-qty__adjust--plus');
      }
      if (!target && r.fallback) target = root.querySelector(r.fallback);
      if (target && (!isDrawer || root.classList.contains('drawer--is-open'))) target.focus({ preventScroll: isDrawer });
    }
    // Only a real refill (a new .cart__items), not the placeholder row added on the tap.
    new MutationObserver(function (records) {
      var refilled = records.some(function (r) {
        return Array.prototype.some.call(r.addedNodes, function (n) { return n.classList && n.classList.contains('cart__items'); });
      });
      if (refilled) sync();
    }).observe(products, { childList: true });
    if (!isDrawer && window.uppEta) window.uppEta(products);
    renderChairs(products);
    fixStale();
    fixProps();

    if (isDrawer) {
      // Clear the "Added" line when the drawer closes (open -> closed only: other class changes such
      // as is-updating during a refill must not wipe it).
      var wasOpen = root.classList.contains('drawer--is-open');
      new MutationObserver(function () {
        var open = root.classList.contains('drawer--is-open');
        if (wasOpen && !open) clearAdded();
        wasOpen = open;
      }).observe(root, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('ajaxProduct:adding', clearAdded);
      document.addEventListener('ajaxProduct:added', function (evt) {
        showAdded(evt.detail && evt.detail.product);
      });
    }

    // Remove without leaving the page; the /cart/change link is the fallback.
    function removeLine(line, rm) {
      if (rm.hasAttribute('data-upp-removing')) return; // a double tap would send the key twice
      rm.setAttribute('data-upp-removing', '');
      clearAdded();
      busyEl.classList.add('is-updating');
      var lines = Array.prototype.slice.call(products.querySelectorAll('.upp-cl'));
      var i = lines.indexOf(line);
      var next = lines[i + 1] || lines[i - 1];
      var fallback = isDrawer ? '#CartDrawerTitle' : null;
      refocus = next ? { key: next.getAttribute('data-key'), sel: '.upp-cl__name', fallback: fallback } : { fallback: fallback };
      theme.cart.changeItem(rm.getAttribute('data-key'), 0)
        .then(function (text) {
          var cart = JSON.parse(text);
          if (cart.status === 422 || !cart.sections) throw new Error(cart.message || 'change failed');
          document.dispatchEvent(new CustomEvent('cart:build', { detail: { sections: cart.sections } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        })
        .catch(function () {
          busyEl.classList.remove('is-updating');
          window.location.href = rm.href;
        });
    }

    /* Minus at quantity 1 (data-upp-minus-remove) removes the line like Remove. Taken in the capture
       phase so theme.js's QtySelector on the button never runs: the input's min="0" makes it send
       quantity "0" as well, and two removals of one key raced; the loser sent the shopper to
       /cart/change (review 2026-10-18). */
    products.addEventListener('click', function (evt) {
      var adj = evt.target.closest && evt.target.closest('[data-upp-minus-remove]');
      var line = adj && adj.closest('.upp-cl');
      var rm = line && line.querySelector('[data-upp-remove]');
      if (!rm || !(window.theme && theme.cart && theme.cart.changeItem)) return;
      evt.stopPropagation();
      evt.preventDefault();
      removeLine(line, rm);
    }, true);

    // Clicks inside the lines: quantity (focus memory), Remove, suggestion Add.
    products.addEventListener('click', function (evt) {
      var t = evt.target;
      var line = t.closest('.upp-cl');

      var adj = t.closest('.js-qty__adjust');
      if (adj && line) {
        clearAdded();
        refocus = { key: line.getAttribute('data-key'), sel: adj.classList.contains('js-qty__adjust--plus') ? '.js-qty__adjust--plus' : '.js-qty__adjust--minus' };
        return;
      }

      var rm = t.closest('[data-upp-remove]');
      if (rm && window.theme && theme.cart && theme.cart.changeItem) {
        evt.preventDefault();
        removeLine(line, rm);
        return;
      }

      // Expedite reminder (per piece) and Remove on an add-on (owner 2026-10-17): read the cart, then
      // change the piece's Delivery + link and the fee line; the last call returns the drawer section and
      // the aria-live line says what happened. Order matters (review 2026-10-18): an add puts the fee
      // line in first and marks the piece only once it's there; a remove puts the piece back on Standard
      // first. A failure halfway then leaves at most a fee line with no piece, which the resync below
      // (addonUpdates) drops, never a piece promised Expedite / White glove with no fee.
      var expAdd = t.closest('[data-upp-exp-add]');
      var wgAddB = t.closest('[data-upp-wg-add]');
      var addonRm = t.closest('[data-upp-addon-rm]');
      if (expAdd || wgAddB || addonRm) {
        evt.preventDefault();
        var btn = expAdd || wgAddB || addonRm;
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        busyEl.classList.add('is-updating');
        clearAdded();
        var rootU = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var hdr = { 'Content-Type': 'application/json', Accept: 'application/json' };
        var secName = window.theme && theme.cart && theme.cart.drawerSection;
        var kind = expAdd ? 'exp-add' : wgAddB ? 'wg-add' : addonRm.getAttribute('data-upp-addon-rm');
        var failNote = expAdd ? 'Couldn\'t add expedited production. Please try again.'
          : wgAddB ? 'Couldn\'t add white glove delivery. Please try again.'
          : 'Couldn\'t remove it. Please try again.';
        var idx = Array.prototype.indexOf.call(products.querySelectorAll('.upp-cl'), line);
        // A 422 (JSON with status) or a non-JSON reply (Shopify's 429 page) is a failure too.
        var post = function (url, body, withSections) {
          if (withSections && secName) body.sections = secName;
          return fetch(rootU + url, { method: 'POST', credentials: 'same-origin', headers: hdr, body: JSON.stringify(body) })
            .then(function (r) {
              return r.json().then(function (res) {
                if (!r.ok || !res || res.status) throw new Error((res && res.message) || 'cart request failed');
                return res;
              });
            });
        };
        var setProps = function (it, delivery, link, withSections) {
          var props = Object.assign({}, it.properties || {}, { 'Delivery': delivery, '_upp_link': link });
          return post('cart/change.js', { id: it.key, quantity: it.quantity, properties: props }, withSections);
        };
        // Refill this cart from a reply; focus goes back to the piece (by its new key when known).
        var refill = function (res, note, key) {
          staleNote = note;
          refocus = { key: key || null, idx: idx, sel: '.upp-cl__name', fallback: isDrawer ? '#CartDrawerTitle' : null };
          if (res.sections || isDrawer) document.dispatchEvent(new CustomEvent('cart:build', { detail: { sections: res.sections } }));
          else window.location.reload();
        };
        var linkedKey = function (res, link) {
          var it = (res.items || []).filter(function (x) { return (x.properties || {})._upp_link === link; })[0];
          return it && it.key;
        };
        fetch(rootU + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var byKey = function (k) { return cart.items.filter(function (x) { return x.key === k; })[0]; };
            if (kind === 'exp-add') {
              var piece = byKey(btn.getAttribute('data-key'));
              if (!piece) throw new Error('line gone');
              var link = 'u' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
              var name = String(piece.product_title || '').split(',')[0].trim();
              return post('cart/add.js', { items: [{ id: Number(btn.getAttribute('data-variant')), quantity: piece.quantity, properties: { '_upp_for': link, 'For': name } }] })
                .then(function () { return setProps(piece, 'Expedited production', link, true); })
                .then(function (res) { refill(res, 'Expedited production added.', linkedKey(res, link)); });
            }
            if (kind === 'wg-add') {
              /* White glove: same steps as Expedite; one order line, then the piece gets Delivery "White glove" + a link */
              var pw = byKey(btn.getAttribute('data-key'));
              if (!pw) throw new Error('line gone');
              var linkW = 'u' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
              return post('cart/add.js', { items: [{ id: Number(btn.getAttribute('data-variant')), quantity: 1, properties: { '_upp_wg': '1' } }] })
                .then(function () { return setProps(pw, 'White glove', linkW, true); })
                .then(function (res) { refill(res, 'White glove added.', linkedKey(res, linkW)); });
            }
            if (kind === 'exp') {
              var p2 = byKey(btn.getAttribute('data-key'));
              var u = {};
              u[btn.getAttribute('data-addon-key')] = 0;
              return (p2 ? setProps(p2, '', '') : Promise.resolve())
                .then(function () { return post('cart/update.js', { updates: u }, true); })
                .then(function (res) { refill(res, 'Expedited production removed.'); });
            }
            // 'wg': every white glove piece back to Standard, then drop the order line(s)
            var pieces = cart.items.filter(function (x) { return /^White glove/.test((x.properties || {}).Delivery || ''); });
            var wgLines = cart.items.filter(function (x) { return (x.properties || {})._upp_wg; });
            var uw = {};
            wgLines.forEach(function (x) { uw[x.key] = 0; });
            return pieces.reduce(function (chain, it) { return chain.then(function () { return setProps(it, '', ''); }); }, Promise.resolve())
              .then(function () { return post('cart/update.js', { updates: uw }, true); })
              .then(function (res) { refill(res, 'White glove removed.'); });
          })
          .catch(function () {
            // Drop any fee line left without its piece and show the cart as it really is now.
            fetch(rootU + 'cart.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (c) { return post('cart/update.js', { updates: addonUpdates(c) || {} }, true); })
              .then(function (res) { refill(res, failNote); })
              .catch(function () {
                busyEl.classList.remove('is-updating');
                btn.removeAttribute('aria-busy');
                if (addedEl) addedEl.textContent = failNote;
              });
          });
        return;
      }

      var add = t.closest('[data-upp-suggest]');
      if (add) {
        evt.preventDefault();
        if (!suggestForm || !(window.theme && theme.AjaxProduct)) return;
        suggestForm.querySelector('[name="id"]').value = add.getAttribute('data-variant');
        suggestForm.querySelector('[name="quantity"]').value = add.getAttribute('data-qty');
        add.setAttribute('aria-busy', 'true');
        refocus = { fallback: '[data-upp-added]' };
        suggestBtn = add;
        suggestErr = '';
        // theme.AjaxProduct fires ajaxProduct:adding on the form right away; without it (another add
        // still running) nothing was sent, so free the button again.
        var started = false;
        var onStart = function () { started = true; };
        suggestForm.addEventListener('ajaxProduct:adding', onStart);
        // On /cart, theme.AjaxProduct reloads the page after the add.
        if (suggestForm.requestSubmit) suggestForm.requestSubmit();
        else suggestForm.dispatchEvent(new Event('submit', { cancelable: true }));
        suggestForm.removeEventListener('ajaxProduct:adding', onStart);
        if (!started) { add.removeAttribute('aria-busy'); suggestBtn = null; refocus = null; }
      }
    });

    /* Chair suggestion Add that fails (review 2026-10-18): theme.AjaxProduct writes the error into the
       hidden #UppCartSuggestForm and theme.CartDrawer closes the drawer "so the product form's error
       shows", which hid the message and left the button busy. Say it in the "Added" line instead and
       keep the drawer open: this window capture listener runs before CartDrawer's document listener, so
       stopping the event there skips the close; its cancelUpdating is done here. */
    var suggestBtn = null, suggestErr = '';
    if (suggestForm) {
      suggestForm.addEventListener('ajaxProduct:error', function (evt) {
        if (!suggestBtn) return;
        var m = evt.detail && evt.detail.errorMessage;
        suggestErr = typeof m === 'string' && m ? m : 'Couldn\'t add the chairs. Please try again.';
      });
      document.addEventListener('ajaxProduct:added', function () { suggestBtn = null; });
      window.addEventListener('ajaxProduct:addFailed', function (evt) {
        if (!suggestBtn) return;
        var b = suggestBtn;
        var msg = suggestErr || 'Couldn\'t add the chairs. Please try again.'; // Shopify's 422 text, e.g. a stock limit
        var reloads = !!suggestErr && document.body.classList.contains('template-cart'); // 422 on /cart reloads
        suggestBtn = null;
        suggestErr = '';
        refocus = null;
        b.removeAttribute('aria-busy');
        if (isDrawer) {
          evt.stopImmediatePropagation();
          busyEl.classList.remove('is-updating');
          var skel = products.querySelector('.iwa-cart-skel');
          if (skel) skel.remove();
        }
        if (addedEl) addedEl.textContent = msg;
        if (reloads) { try { sessionStorage.setItem('uppCartNote', msg); } catch (e) { /* note is lost */ } }
      }, true);
    }
    if (!isDrawer && addedEl) {
      try {
        var kept = sessionStorage.getItem('uppCartNote');
        if (kept) { sessionStorage.removeItem('uppCartNote'); addedEl.textContent = kept; }
      } catch (e) { /* no note */ }
    }

    // Quantity typed into the field: keep focus on it after the refill.
    products.addEventListener('change', function (evt) {
      var line = evt.target.closest('.upp-cl');
      if (line && evt.target.classList.contains('js-qty__num')) {
        clearAdded();
        refocus = { key: line.getAttribute('data-key'), sel: '.js-qty__num' };
      }
    });
  }

  if (drawer) wire(drawer, true);
  if (page) wire(page, false);

  // "Add a note to your order"
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-upp-note-toggle]');
    if (!btn) return;
    var wrap = document.getElementById(btn.getAttribute('aria-controls'));
    if (!wrap) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    wrap.hidden = !open;
    if (open) {
      var ta = wrap.querySelector('textarea');
      if (ta) ta.focus();
    }
  });

  // Delivery add-ons: quantities the cart should have, or null when it's already right.
  function addonUpdates(cart) {
    var u = {}, pieces = {}, wgWanted = false, wgLines = [];
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._upp_for || p._upp_wg) return;
      if (p._upp_link) pieces[p._upp_link] = (pieces[p._upp_link] || 0) + it.quantity;
      if (/^White glove/.test(p.Delivery || '')) wgWanted = true;
    });
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._upp_for) {
        var want = pieces[p._upp_for] || 0;
        if (it.quantity !== want) u[it.key] = want;
      } else if (p._upp_wg) {
        wgLines.push(it);
      }
    });
    wgLines.forEach(function (it, i) {
      var want = wgWanted && i === 0 ? 1 : 0;
      if (it.quantity !== want) u[it.key] = want;
    });
    return Object.keys(u).length ? u : null;
  }
  var reconciling = false;
  function reconcile(cart) {
    if (reconciling || !window.fetch) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function go(c) {
      var u = c && c.items ? addonUpdates(c) : null;
      if (!u) return;
      reconciling = true;
      var body = { updates: u };
      var sec = window.theme && theme.cart && theme.cart.drawerSection;
      if (sec) body.sections = sec;
      fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (c2) {
          reconciling = false;
          if (!c2 || !c2.items) return;
          if (c2.sections) document.dispatchEvent(new CustomEvent('cart:build', { detail: { sections: c2.sections } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c2 } }));
        })
        .catch(function () { reconciling = false; });
    }
    if (cart && cart.items) go(cart);
    else fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(go).catch(function () {});
  }
  document.addEventListener('cart:updated', function (evt) { reconcile(evt.detail && evt.detail.cart); });
  document.addEventListener('ajaxProduct:added', function () { reconcile(); });
  if (document.querySelector('[data-upp-addons]')) reconcile();

  // The suggestion form posts through Impulse's AjaxProduct: placeholder row, refill, "Added" line.
  function bindSuggest() {
    if (suggestForm && window.theme && theme.AjaxProduct) {
      new theme.AjaxProduct(suggestForm, '[data-upp-suggest-submit]');
      return true;
    }
    return false;
  }
  if (!bindSuggest()) document.addEventListener('DOMContentLoaded', bindSuggest);
})();
